import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersDeposits = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/deposits/list`, {params});
};